module.exports = __webpack_public_path__ + "static/media/burger.6f9b7198.svg";